<div class="p-6">
  <app-display-projects (openAdd)="openModal()"></app-display-projects>
  @if(showModal) {
    <div class="fixed inset-0 z-9999 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4 animate-fade-in"
         (click)="closeModal()">
      <div (click)="$event.stopPropagation()" class="w-full flex justify-center">
        <app-add-project (close)="closeModal()"></app-add-project>
      </div>
    </div>
  }
</div>
